import {LOANS} from 'loans.module/common/domain/constants.loans';

const STATES = LOANS.STATES.ID;
const loansStates = {};

loansStates[STATES.CANCELLED] = { // 0 - Cancelado
  text: 'LOANS.MY_LOANS_CARD.STATES.CANCELLED',
  icon: 'icon icon-cancel',
  mapTo: STATES.NOT_IN_FORCE,
  title: '',
  textFilter: ''
};

loansStates[STATES.IN_STUDIO] = { // 1 - Activo
  text: 'LOANS.MY_LOANS_CARD.STATES.IN_STUDIO',
  icon: 'icon icon-approved',
  mapTo: STATES.IN_STUDIO,
  title: '',
  textFilter: ''
};

loansStates[STATES.AUTHORIZED] = { // A - Autorizado
  text: 'LOANS.MY_LOANS_CARD.STATES.AUTHORIZED',
  icon: 'icon icon-authorized',
  mapTo: STATES.AUTHORIZED,
  title: 'LOANS.LOANS_FILTERS.TITLES.AUTHORIZED',
  textFilter: 'LOANS.LOANS_FILTERS.TEXT.AUTHORIZED'
};

loansStates[STATES.ANNULATED] = { // B - Anulado
  text: 'LOANS.MY_LOANS_CARD.STATES.ANNULATED',
  icon: 'icon icon-cancel',
  mapTo: STATES.NOT_IN_FORCE,
  title: '',
  textFilter: ''
};

loansStates[STATES.DISCLAIMER] = { // C - Renunciado
  text: 'LOANS.MY_LOANS_CARD.STATES.DISCLAIMER',
  icon: 'icon icon-cancel',
  mapTo: STATES.NOT_IN_FORCE,
  title: '',
  textFilter: ''
};

loansStates[STATES.DENIED] = { // D - Denegado
  text: 'LOANS.MY_LOANS_CARD.STATES.DENIED',
  icon: 'icon icon-cross-circle-deny',
  mapTo: STATES.DENIED,
  title: 'LOANS.LOANS_FILTERS.TITLES.DENIED',
  textFilter: 'LOANS.LOANS_FILTERS.TEXT.DENIED'
};

loansStates[STATES.IN_FORCE] = { // L - En vigor
  text: 'LOANS.MY_LOANS_CARD.STATES.IN_FORCE',
  icon: 'icon icon-approved',
  mapTo: STATES.IN_FORCE,
  title: 'LOANS.LOANS_FILTERS.TITLES.IN_FORCE',
  textFilter: 'LOANS.LOANS_FILTERS.TEXT.IN_FORCE'
};

loansStates[STATES.NOT_IN_FORCE] = { // N - No vigente
  text: 'LOANS.MY_LOANS_CARD.STATES.NOT_IN_FORCE',
  icon: 'icon icon-cross-circle',
  mapTo: STATES.NOT_IN_FORCE,
  title: 'LOANS.LOANS_FILTERS.TITLES.NOT_IN_FORCE',
  textFilter: 'LOANS.LOANS_FILTERS.TEXT.NOT_IN_FORCE'
};

loansStates[STATES.PENDING] = { // P - Pendiente
  text: 'LOANS.MY_LOANS_CARD.STATES.PENDING',
  icon: 'icon icon-requested',
  mapTo: STATES.PENDING,
  title: 'LOANS.LOANS_FILTERS.TITLES.PENDING',
  textFilter: 'LOANS.LOANS_FILTERS.TEXT.PENDING'
};

loansStates[STATES.REGRESSED] = { // R - Retrocedido
  text: 'LOANS.MY_LOANS_CARD.STATES.REGRESSED',
  icon: 'icon icon-requested',
  mapTo: STATES.NOT_IN_FORCE,
  title: '',
  textFilter: ''
};

loansStates[STATES.SUBSCRIBER] = { // X - Abonado
  text: 'LOANS.MY_LOANS_CARD.STATES.SUBSCRIBER',
  icon: 'icon icon-approved',
  mapTo: STATES.IN_FORCE,
  title: '',
  textFilter: ''
};

loansStates[STATES.TRANSITIONAL_INTEGRATION] = { // Z - Transitorio de integración
  text: 'LOANS.MY_LOANS_CARD.STATES.TRANSITIONAL_INTEGRATION',
  icon: 'icon icon-requested',
  mapTo: STATES.TRANSITIONAL_INTEGRATION,
  title: '',
  textFilter: ''
};

loansStates[STATES.PENDING_SIGNATURE] = { // F - Pendiente de firma
  text: 'LOANS.MY_LOANS_CARD.STATES.PENDING_SIGNATURE',
  icon: 'icon icon-pencil-circle',
  mapTo: STATES.PENDING_SIGNATURE,
  title: 'LOANS.LOANS_FILTERS.TITLES.PENDING_SIGNATURE',
  textFilter: 'LOANS.LOANS_FILTERS.TEXT.PENDING_SIGNATURE'
};

export default class LoansStatesService {

  get states() {
    return STATES;
  }

  get statesFilters() {
    let statesToFilter = angular.copy(STATES);
    for (const state in STATES) {
      if (!this._checkStatesToFilter(STATES[state])) {
        delete statesToFilter[state];
      }
    }

    return {
      statesToFilter: statesToFilter,
      loansStates: loansStates,
    };
  }

  _checkStatesToFilter(state) {
    return state === STATES.IN_FORCE || state === STATES.AUTHORIZED || state === STATES.PENDING || state === STATES.PENDING_SIGNATURE || state === STATES.NOT_IN_FORCE || state === STATES.DENIED;
  }

  getAll() {
    return loansStates;
  }

  mapStatusCode(loan) {
    loan.originalStatusCode = loan.statusCode;
    loan.statusCode = loansStates[loan.statusCode].mapTo;
    return loan;
  }
}



// WEBPACK FOOTER //
// ./client/app/loans.module/common/services/loans.states.service.js